/** @jsx jsx */
import React, { useState, Dispatch } from 'react';
import { Link } from 'react-router-dom';

import OrganizationDomain from 'domain/organization';

import FormField from 'components/atoms/Form/FormField';
import TextForm from 'components/molecules/TextForm';
import FormSubmitArea from 'components/atoms/Form/FormSubmitArea';
import Button, {SecondaryButton} from 'components/atoms/Button';
import ConfirmModal from 'components/organismos/ConfirmModal';
import Checkbox from 'components/molecules/Checkbox';
import Modal from 'components/molecules/Modal';
import FlexBox from 'components/atoms/FlexBox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import DataTable from 'components/organismos/DataTable/DataTable';
import { Column } from 'react-table';
import { useOrganizationAddForm } from './hooks';
import { useOrganizationDelete } from '../OrganizationListTable/hooks';
import { InfoButton } from 'components/atoms/Button';
import { css, jsx } from '@emotion/core';
import FormPadding from 'components/atoms/Form/FormPadding';
import CalendarForm from 'components/molecules/CalendarForm';
import { grayScale, textFontSize } from 'components/styles';
import FormLabel from 'components/atoms/Form/FormLabel';

import usePrefectureOptions from 'hooks/usePrefectureOptions';
import useEmploymentOptions from 'hooks/useEmploymentOptions';
import useWorkingDayOptions from 'hooks/useWorkingDayOptions';
import SelectFormV2 from 'components/molecules/SelectFormV2';
import SelectForm from 'components/molecules/SelectForm';
import Calendar from 'components/molecules/CalendarV1';
import VerticalLabelFormLayout from 'components/atoms/Form/VerticalLabelFormLayout';
const isIpad = window.matchMedia("(max-width: 1024px)").matches;

// const listHours = [
//   '00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
//   '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
//   '20', '21', '22', '23',
// ];
// const listTimes = [
//   '00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
//   '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
//   '20', '21', '22', '23', '24', '25', '26', '27', '28', '29',
//   '30', '31', '32', '33', '34', '35', '36', '37', '38', '39',
//   '40', '41', '42', '43', '44', '45', '46', '47', '48', '49',
//   '50', '51', '52', '53', '54', '55', '56', '57', '58', '59',
// ];

// const arrListHours = (listHours.map((Hours) => ({
//   value: Hours,
//   label: Hours,
// })));

// const arrListTimes = (listTimes.map((Times) => ({
//   value: Times,
//   label: Times,
// })));

const OrganizationInputForm: React.FC<{
  initialOrganizationDomain?: OrganizationDomain;
  setInitialOrganizationDomain: Dispatch<React.SetStateAction<OrganizationDomain>>;
  historyList: Array<OrganizationDomain>
  isEditMode?: boolean;
  setHistoryList: (arg: Array<OrganizationDomain>) => void;
  isDisabledInfo?: boolean;
}> = ({
  initialOrganizationDomain, setInitialOrganizationDomain,
  historyList, isEditMode = false, setHistoryList,
  isDisabledInfo = false
}) => {
  const {
    formik,
    // detailMode, setDetailMode
    confirmModalOpen, closeConfirmModal,
  } = useOrganizationAddForm(
    initialOrganizationDomain,
    isEditMode,
    historyList,
    setHistoryList,
  );
  // console.log(`initialOrganizationDomain = ${initialOrganizationDomain?.orgCode}`);
  const prefectureOptions = usePrefectureOptions();
  const employmentOptions = useEmploymentOptions();
  const workingDayOptions = useWorkingDayOptions();

  const {
    deleteTargetOrganization, setDeleteTargetOrganization,
    isOpenDeleteModal,
    closeDeleteModal, onSubmitDeleteOrganization,
  } = useOrganizationDelete();

  const columns: Array<Column<OrganizationDomain>> = React.useMemo(() => [
    {
      Header: () => null,
      accessor: 'x',
      disableSortBy: true,
      id: 'actionButton',
      Cell: (cell: { row :{ isExpanded: boolean, original: OrganizationDomain }}) => {
        // eslint-disable-next-line
        const [isHoverEdit, setIsHoverEdit] = useState(false);
        return (
          <FlexBox>
            <FlexBoxItem margin="0 auto">
              <InfoButton text="編集"
                minWidth={'40px'}
                customStyle={css({ borderRadius: '3px', fontSize: '12px', lineHeight: '10px', padding: '0 5px', height: '24px' })}
                onClick={
                  () => {
                    formik.setFieldValue('orgName', cell.row.original.orgName);
                    formik.setFieldValue('category', cell.row.original.category);
                    formik.setFieldValue('applyStartDate', cell.row.original.applyStartDate);
                    formik.setFieldValue('closeFlag', cell.row.original.closeFlag);
                    formik.setFieldValue('prefectureCode', cell.row.original.prefectureCode);
                    formik.setFieldValue('areaId', cell.row.original.areaId);
                    formik.setFieldValue('businessCategoryId', cell.row.original.businessCategoryId);
                    formik.setFieldValue('employmentId', cell.row.original.employmentId);
                    formik.setFieldValue('workingDaysId', cell.row.original.workingDaysId);
                    formik.setFieldValue('posCode', cell.row.original.posCode);
                    formik.setFieldValue('numberOfSeat', cell.row.original.numberOfSeat);
                    formik.setFieldValue('floorSpace', cell.row.original.floorSpace);
                  }
                }
              />
            </FlexBoxItem>
          </FlexBox>
        );
      },
    },
    {
      Header: '適用日',
      accessor: 'applyStartDateText',
    },
    {
      Header: '組織コード',
      accessor: 'orgCode',
    },
    {
      Header: '組織名',
      accessor: 'orgName',
    },
    // {
    //   Header: '表示営業時間',
    //   accessor: 'dispStartHour'
    // },
    {
      Header: '状態',
      accessor: 'closeFlagLabel',
    },
  ], [formik]);

  const textLabel = {
    color: grayScale.gray60,
    fontSize: textFontSize.re
  }

  // const workingDaysItem = workingDayOptions.find((elm) => {
  //   return elm.value === formik.values.workingDaysId
  // });

  // const labelWorkingDays = workingDaysItem?.label;

  return (
    <React.Fragment>
      {historyList
      && historyList.length !== 0 && (
        <div
          css={css`
          table th:nth-of-type(1) {
            width: 45px;
          }
          table th:nth-of-type(2) {
            width: 80px;
          }
          table th:nth-of-type(3) {
            width: 180px;
          }
          table th:nth-of-type(4) {
            width: ${isIpad && '300px'}
          }
          table th:nth-of-type(5) {
            width: 180px;
          }
          table tr td:nth-of-type(2){
            text-align: center;
          }
          table tr td:nth-of-type(3){
            text-align: center;
          }
          table th{
            text-align: center;
          }
        `}
        >
          <div 
            className="table-bordered table-padding" 
            style={{ overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom: '15px' }}
          >
            <DataTable
              classNameParrant="border-left-right"
              className="table-no-border-left-right"
              columns={columns}
              data={historyList}
              isGlobalFilter={false}
              minWidth="632px"
            />
          </div>
        </div>
      )}

      <FormPadding customStyle={{ padding: '0 25% 16px' }}>
        <form onSubmit={formik.handleSubmit}>
          <div>
            <FormField>
              <div style={{ marginRight: '12px' }}>
                <VerticalLabelFormLayout 
                label={(
                  <FormLabel
                    label="適用日"
                    required={true}
                  /> 
                )}
                input={(
                  <Calendar 
                  date={formik.values.applyStartDate}
                  setDate={(date) => {
                    if(date){
                      formik.setFieldValue('applyStartDate', date)
                    }
                  }}
                  readOnly={isDisabledInfo}
                  />
                )}
                />
                {/* <CalendarForm
                  label="適用日"
                  date={formik.values.applyStartDate}
                  dateFormat="YYYY/MM/DD"
                  changeDate={(date: Date) => formik.setFieldValue('applyStartDate', date)}
                  required={true}
                  readOnly={isDisabledInfo}
                /> */}
              </div>
            </FormField>

            <FormField>
              <TextForm
                name="orgCode"
                label="組織コード"
                value={formik.values.orgCode}
                onChange={formik.handleChange}
                errorMsg={formik.errors.orgCode}
                required={true}
                disable={isDisabledInfo||isEditMode}
              />
            </FormField>

            <FormField>
              <TextForm
                name="orgName"
                label="組織名"
                value={formik.values.orgName}
                onChange={formik.handleChange}
                errorMsg={formik.errors.orgName}
                required={true}
                disable={isDisabledInfo}
              />
            </FormField>

            <FormField>
              <TextForm
                name="orgNameKana"
                label="組織名（ふりがな）"
                value={formik.values.orgNameKana}
                onChange={formik.handleChange}
                errorMsg={formik.errors.orgNameKana}
              />
            </FormField>

            {/* <FormField displayBlock={true}>
              <div style={textLabel}>組織カテゴリー</div>
              <VerticalLabelSelectForm
                label=""
                name="category"
                value={String(formik.values.category)}
                setValue={(category) => {
                  formik.setFieldValue('category', category);
                }}
                placeholder="スタッフを選択してください"
                options={[
                  {
                    label: OrganizationCategoryLabel[2],
                    value: '2',
                  },
                  {
                    label: OrganizationCategoryLabel[1],
                    value: '1',
                  },
                  {
                    label: OrganizationCategoryLabel[0],
                    value: '0',
                  },
                ]}
                widthLabel="0"
              />
            </FormField> */}

            <FormField displayBlock={true}>
              <div style={textLabel}>所在地</div>
              <SelectForm
                label=""
                name="prefectureCode"
                value={String(formik.values.prefectureCode)}
                setValue={(prefectureCode) => {
                  formik.setFieldValue('prefectureCode', prefectureCode);
                }}
                options={prefectureOptions}
                widthLabel="0"
              />
            </FormField>

            <FormField displayBlock={true}>
              <div style={textLabel}>所定労働日数</div>
              <SelectForm
                label=""
                name="workingDaysId"
                value={String(formik.values.workingDaysId)}
                setValue={(workingDaysId) => {
                  formik.setFieldValue('workingDaysId', workingDaysId);
                }}
                options={workingDayOptions}
                widthLabel="0"
              />
            </FormField>

            <FormField displayBlock={true}>
              <div style={textLabel}>雇用形態</div>
              <SelectForm
                label=""
                name="employmentId"
                value={String(formik.values.employmentId)}
                setValue={(employmentId) => {
                  formik.setFieldValue('employmentId', employmentId);
                }}
                options={employmentOptions}
                widthLabel="0"
              />
            </FormField>

            {/* <FormField displayBlock={true}>
              <FormLabel
                label="表示営業時間"
                required={true}
              />
            </FormField>

            <Row>
              <Col xs={6}>
                <FormField displayBlock={true}>
                  <FormLabel
                    label="開始時間"
                  />
                </FormField>

                <FormField customStyle={css({ paddingTop: '0px' })}>
                  <Col xs={4}>
                  <FlexBox>
                  <Col xs={12}>
                    <VerticalLabelSelectForm
                      name="dispStartHour"
                      value={String(formik.values.dispStartHour)}
                      setValue={(dispStartHour) => {
                        formik.setFieldValue('dispStartHour', dispStartHour);
                      }}
                      options={arrListHours}
                      menuPlacement="bottom"
                      placeholder=" "
                    />
                  </Col>
                  </FlexBox>
                  </Col>
                  <Col xs={1} style={{ textAlign: 'center', paddingTop: '10px' }}>:</Col>
                  <Col xs={4}>
                  <FlexBox>
                    <Col xs={12}>
                      <VerticalLabelSelectForm
                        name="dispHour"
                        value={String(formik.values.dispHour)}
                        setValue={(dispHour) => {
                          formik.setFieldValue('dispHour', dispHour);
                        }}
                        options={arrListTimes}
                        menuPlacement="bottom"
                        placeholder=" "
                      />
                    </Col>
                  </FlexBox>
                  </Col>
                  <FlexBox customStyle={css({ paddingLeft: '10px' })}>
                    <Checkbox
                      id="nextDay"
                      name="nextDay"
                      value=""
                      label="翌日"
                      checked={false}
                      onChange={() => {}}
                    />
                  </FlexBox>
                </FormField>
              </Col>
              <Col xs={6}>
                <FormField displayBlock={true}>
                  <FormLabel
                    label="終了時間"
                  />
                </FormField>

                <FormField customStyle={css({ paddingTop: '0px' })}>
                  <Col xs={4}>
                  <FlexBox>
                  <Col xs={12}>
                    <SelectForm
                      name="dispStartHour"
                      value="01"
                      setValue={(val: string) => []}
                      options={arrListHours}
                      menuPlacement="bottom"
                    />
                  </Col>
                  </FlexBox>
                  </Col>
                  <Col xs={1} style={{ textAlign: 'center', paddingTop: '10px' }}>:</Col>
                  <Col xs={4}>
                  <FlexBox>
                    <Col xs={12}>
                      <VerticalLabelSelectForm
                        name="dispStartHour"
                        value="01"
                        setValue={(val: string) => []}
                        options={arrListTimes}
                        menuPlacement="bottom"
                      />
                    </Col>
                  </FlexBox>
                  </Col>
                  <FlexBox customStyle={css({ paddingLeft: '10px' })}>
                    <Checkbox
                      id="nextDay"
                      name="nextDay"
                      value=""
                      label="翌日"
                      checked={false}
                      onChange={() => {}}
                    />
                  </FlexBox>
                </FormField>
                </Col>
            </Row> */}

            <FormField displayBlock={true}>
              <FormLabel
                label="状態"
              />

              <FlexBox>
                <Checkbox
                  id="closeFlag"
                  name="closeFlag"
                  value=""
                  label="廃止"
                  checked={formik.values.closeFlag}
                  onChange={formik.handleChange}
                />
              </FlexBox>
            </FormField>

            {/* <FormField>

              <div style={{ marginRight: '12px' }}>
                <VerticalLabelFormLayout
                  label={(
                    <FormLabel
                      label="表示営業時間"
                    />
                  )}
                  input={(
                    <FlexBox>
                      <HourInput
                        name="dispStartHour"
                        value={formik.values.dispStartHour}
                        label="時"
                        onChange={formik.handleChange}
                      />
                      <div>
                        から
                      </div>
                      <HourInput
                        name="dispHour"
                        value={formik.values.dispHour}
                        label="時間"
                        onChange={formik.handleChange}
                      />
                    </FlexBox>
                  )}
                />
              </div>
              <RadioSelectForm
                label="組織状態"
                name="closeFlag"
                items={[
                  {
                    label: '設立',
                    value: 'open',
                  },
                  {
                    label: '廃止',
                    value: 'close',
                  },
                ]}
                value={String(formik.values.closeFlag)}
                setValue={formik.handleChange}
              />
            </FormField> */}
          </div>

          {/* 組織詳細項目 */}
          {/* {detailMode && formik.values.category === OrganizationCategory.STORE && (
            <StoreDetailForm
              prefectureCode={formik.values.prefectureCode}
              setPrefectureCode={(val: string) => formik.setFieldValue('prefectureCode', val)}
              areaId={formik.values.areaId}
              setAreaId={(val: string) => formik.setFieldValue('areaId', val)}
              businessCategoryId={formik.values.businessCategoryId}
              setBusinessCategoryId={(val: string) => formik.setFieldValue('businessCategoryId', val)}
              employmentId={formik.values.employmentId}
              setEmploymentId={(val: string) => formik.setFieldValue('employmentId', val)}
              workingDaysId={formik.values.workingDaysId}
              setWorkingDaysId={(val: string) => formik.setFieldValue('workingDaysId', val)}
              posCode={formik.values.posCode}
              setPosCode={(val: string) => formik.setFieldValue('posCode', val)}
              numberOfSeat={formik.values.numberOfSeat}
              setNumberOfSeat={(val: string) => formik.setFieldValue('numberOfSeat', val)}
              floorSpace={formik.values.floorSpace}
              setFloorSpace={(val: string) => formik.setFieldValue('floorSpace', val)}
            />
          )} */}

          {/* 部署詳細項目 */}
          {/* {detailMode && formik.values.category === OrganizationCategory.DEPARTMENT && (
            <DepartmentDetailForm
              prefectureCode={formik.values.prefectureCode}
              setPrefectureCode={(val: string) => formik.setFieldValue('prefectureCode', val)}
              employmentId={formik.values.employmentId}
              setEmploymentId={(val: string) => formik.setFieldValue('employmentId', val)}
              workingDaysId={formik.values.workingDaysId}
              setWorkingDaysId={(val: string) => formik.setFieldValue('workingDaysId', val)}
            />
          )} */}

          <FormSubmitArea customStyle={css({ textAlign: 'center' })}>
            <div>
              <Button
                minWidth="160px"
                text={isEditMode ? '更新' : '登録'}
                onClick={formik.handleSubmit}
              />

            {isEditMode && !isDisabledInfo &&
              <SecondaryButton
                text={'削除'}
                onClick={() => setDeleteTargetOrganization(formik.values)}
                minWidth="160px"
                customStyle={css({ marginLeft: '10px' })}
              />
            }
            </div>
            <Link to="/organizations">
              <Button
                minWidth="160px"
                text="キャンセル"
                ghost={true}
              />
            </Link>
          </FormSubmitArea>
        </form>
      </FormPadding>

      {/* 登録内容確認モーダル */}
      {/* <ConfirmModal
        open={confirmModalOpen}
        closeHandler={closeConfirmModal}
        onSubmit={formik.handleSubmit}
        items={confirmModalItems}
      /> */}
      <ConfirmModal
        open={confirmModalOpen}
        closeHandler={closeConfirmModal}
        onSubmit={formik.handleSubmit}
        title={`${isEditMode ? '組織マスタの更新' : '組織マスタの登録'}`}
        content={`${isEditMode ? '組織マスタを更新します。よろしいですか？' : '組織マスタを登録します。よろしいですか？'}`}
        submitText={isEditMode ? '更新' : '登録する'}
      />
      <Modal
        typeSubmit='reject'
        open={isOpenDeleteModal}
        closeHandler={closeDeleteModal}
        submitText="削除"
        title="組織を削除"
        onSubmit={onSubmitDeleteOrganization}
      >
        <div style={{ textAlign: 'center', fontWeight: 'normal', fontSize: '14px', color: '#666666', marginBottom: '15px' }}>
          {deleteTargetOrganization?.orgName}
          組織を削除します。よろしいですか？
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default OrganizationInputForm;
